import type { Customer } from "@onsemble/shared";

/**
 * Get display name for a customer based on their type
 * @param customer - The customer object (or null/undefined). Can be partial since only firstName, lastName, businessName, and customerType are needed.
 * @param shortened - If true, returns only first name for person customers (default: false)
 * @returns Display name string
 */
export function getCustomerDisplayName(
  customer: Partial<Customer> | null | undefined,
  shortened: boolean = false,
): string {
  if (!customer) {
    return "Customer";
  }

  if (customer.customerType === "business") {
    return customer.businessName || "Customer";
  }

  // Person customer
  if (shortened) {
    return customer.firstName || "Customer";
  }

  return (
    `${customer.firstName || ""} ${customer.lastName || ""}`.trim() ||
    "Customer"
  );
}
